import { parseQuestionsFromText } from "./docxParser";
import type { ParsedQuestionDocResult } from "@/types/questions";

/**
 * Browser-side path: read a .docx File via mammoth and parse.
 * (Kept separate from docxParser.ts so the pure parser stays
 * lightweight and importable in tests / the Netlify function.)
 */
export async function parseDocxFileInBrowser(file: File): Promise<ParsedQuestionDocResult> {
  const mammothMod = await import("mammoth/mammoth.browser");
  const buf = await file.arrayBuffer();
  const result = await mammothMod.extractRawText({ arrayBuffer: buf });
  return parseQuestionsFromText(result.value);
}
